var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconApple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.647,
    height: 21,
    viewBox: "0 0 17.647 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-apple",
    "data-name": "Icon awesome-apple",
    d: "M15.035,13.347A4.377,4.377,0,0,1,17.38,9.372a5.037,5.037,0,0,0-3.971-2.091c-1.664-.131-3.483.97-4.149.97-.7,0-2.316-.924-3.582-.924-2.616.042-5.4,2.086-5.4,6.245a11.685,11.685,0,0,0,.675,3.807c.6,1.721,2.766,5.94,5.026,5.87C7.164,23.221,8,22.41,9.536,22.41c1.491,0,2.264.839,3.582.839,2.279-.033,4.238-3.868,4.81-5.593a4.648,4.648,0,0,1-2.893-4.309Zm-2.654-7.7a4.416,4.416,0,0,0,1.125-3.4,4.971,4.971,0,0,0-3.183,1.636,4.485,4.485,0,0,0-1.2,3.371,3.938,3.938,0,0,0,3.258-1.608Z",
    transform: "translate(-0.281 -2.25)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconApple);
export default __webpack_public_path__ + "static/media/Icon-Apple.968848f402aea0210e079c5682f3f67e.svg";
export { ForwardRef as ReactComponent };